import { useAsset } from "provider/AssetProvider";
import { usePagePermission } from "provider/PagePermissionProvider";
import { Link } from "react-router-dom";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { ExternalSidebarMenuItem } from "./ExternalSidebarMenuItem";

export function Sidebar() {
    const permission = usePagePermission();
    const { tokenInfo, stakingAddress } = useAsset()

    return <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme color-black">
        <div className="app-brand demo">
            <a href="index.html" className="app-brand-link">
                <span className="app-brand-logo demo w-100">
                    <img className="w-100 p-3" src="/assets/img/logo/garuda-defi-logo-text.png" alt="" />
                </span>
            </a>

            <a href="#" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                <i className="bx bx-chevron-left bx-sm align-middle"></i>
            </a>
        </div>

        <div className="menu-inner-shadow"></div>

        <ul className="menu-inner py-1">

            <SidebarMenuItem
                icon="home-circle"
                label="Home"
                path="/" />

            {
                permission.registerToken && <SidebarMenuItem
                    icon="book-add"
                    path="/register-token"
                    label="Register Token" />
            }

            {
                (permission.stakedAsset && permission.rewards) && <>
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text">Staking ({tokenInfo?.symbol})</span>
                    </li>

                    <SidebarMenuItem
                        stakingAddress={stakingAddress}
                        icon="wallet"
                        label="Staked Asset"
                        path={"/asset"} />

                    <SidebarMenuItem
                        stakingAddress={stakingAddress}
                        icon="coin-stack"
                        label="Rewards"
                        path="/reward" />
                </>
            }

            {
                (permission.managePool && permission.stakingConfig) && <>
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text">Owner ({tokenInfo?.symbol})</span>
                    </li>

                    <SidebarMenuItem
                        stakingAddress={stakingAddress}
                        icon="layer-plus"
                        label="Manage Pool"
                        path="/pool" />

                    <SidebarMenuItem
                        stakingAddress={stakingAddress}
                        icon="cog"
                        label="Staking Config"
                        path="/config" />
                </>
            }



            {
                permission.feeConfig && <>
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text">Admin</span>
                    </li>

                    <SidebarMenuItem
                        icon="dollar"
                        label="Fee Config"
                        path="/fee-config" />
                </>
            }

            <SidebarMenuItem
                svg={<svg xmlns="http://www.w3.org/2000/svg" className="menu-icon tf-icons" width="24" height="24" viewBox="0 0 24 24"><path d="m21.88 2.15-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a8.65 8.65 0 0 0 1.47 6.6c-.06.21-.12.42-.17.63A22.6 22.6 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41zm-7.27 13.93c-2.61 1.11-5.73.92-7.48-.45a13.79 13.79 0 0 1 1.21-2.84A10.17 10.17 0 0 1 9.73 11a9 9 0 0 1 1.81-1.42A12 12 0 0 1 16 8V7a11.43 11.43 0 0 0-5.26 1.08 10.28 10.28 0 0 0-4.12 3.65 15.07 15.07 0 0 0-1 1.87 7 7 0 0 1-.38-3.73 5.24 5.24 0 0 1 3.14-4 8.93 8.93 0 0 1 3.82-.84c.62 0 1.23.06 1.87.11a16.2 16.2 0 0 0 6-.35C20 7.55 19.5 14 14.61 16.08z" fill="#697a8d" /></svg>}
                icon="leaf"
                label="Hybrid Staking"
                path="/hybrid-staking/home" />

            <ExternalSidebarMenuItem
                url="https://nft-staking.garuda-defi.org"
                icon="reward"
                label="NFT Staking" />

            <ExternalSidebarMenuItem
                url="https://nft-staking.garuda-defi.org/cross-staking"
                icon="reward"
                label="Cross Staking" />

            <ExternalSidebarMenuItem
                url="https://nft-staking.garuda-defi.org/presale"
                icon="reward"
                label="GDEX Presale" />


            <ExternalSidebarMenuItem
                url="https://garudauniverse.gitbook.io/garuda-defi"
                icon="file"
                label="Documentation" />
        </ul>


    </aside>
}